export enum BroadcastReceiverTypeEnum {
    None = 0,
    SignedUpInLastXDay = 1,
    CurrentlyOnlineLocation = 2,
    HaventLoggedInXDays = 3,
    All = 4,
    CurrentlyOnline = 5,
    Passenger2W = 6,
    Passenger4W = 7,
    Active = 8,
    Registration = 9,
    CampaignDrivers = 10,
    XpressForRide = 11,
	GeoTagging = 12,
	Ban2WDriversApril26 = 13
}
